module.exports = __webpack_public_path__ + "img/shipo-icon-edit.53903952.svg";